import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';
//TODO: To be removed later;
const mockResponse = {
  storeID: '01342',
  orderID: 'OD30423223',
  itemList: [
    {
      itemIdentifier: '1111',
      discountAmount: 0,
      extSellPrice: 1000,
      itemID: '1234',
      promoList: [],
      quantity: 1,
      sellPrice: 1000,
    },
    {
      itemIdentifier: '1112',
      discountAmount: 14,
      extSellPrice: 36000,
      itemID: '4321',
      promoList: [
        {
          discountAmount: 14,
          promoDesc: 'Buy X get 20 % off',
          promoID: '9999',
        },
      ],
      quantity: 1,
      sellPrice: 50000,
    },
  ],
  productList: {
    '1234': {
      itemDesc: 'ARMADI OFFICE CHAIR',
      itemDept: 'CHAIR',
      itemBrand: 'ARMADI',
      itemColour: 'RED',
      itemSize: 'M',
    },
    '4321': {
      itemDesc: 'AND Flair Top',
      itemDept: 'TOP',
      itemBrand: 'AND',
      itemColour: 'PINK',
      itemSize: 'L',
    },
  },
};

const mockItemResponse = {
  statusCode: '200',
  message: 'Item available in database',
  storeID: '01342',
  orderID: 'OD30423223',
  itemDetail: [
    {
      itemID: '1234',
      itemEAN: '4321',
      itemDesc: 'ARMADI OFFICE CHAIR',
      itemDept: 'CHAIR',
      itemBrand: 'ARMADI',
      itemColour: 'RED',
      itemSize: 'M',
      mmrpFlag: 'Y',
      priceList: [
        {
          sellPrice: 50,
          discountAmount: 14,
          extSellPrice: 36,
          promoList: [
            {
              discountAmount: 10,
              promoDesc: 'Buy X get 20 % off',
              promoID: '9999',
            },
            {
              discountAmount: 4,
              promoDesc: 'Buy X get 10 % off',
              promoID: '8888',
            },
          ],
        },
        {
          sellPrice: 70,
          discountAmount: 28,
          extSellPrice: 42,
          promoList: [
            {
              discountAmount: 28,
              promoDesc: 'Buy X get 40 % off',
              promoID: '4444',
            },
          ],
        },
      ],
    },
  ],
};

const mockCouponResponse = {
  statusCode: '200',
  message: 'coupon applied successfully',
  storeID: '01342',
  orderID: 'OD30423223',
  itemList: [
    {
      itemIdentifier: '1111',
      discountAmount: 0,
      extSellPrice: 100,
      itemID: '1234',
      giftCouponList: [],
      quantity: 1,
      sellPrice: 100,
    },
    {
      itemIdentifier: '1112',
      discountAmount: 15,
      extSellPrice: 35,
      itemID: '4321',
      giftCouponList: [
        {
          discountAmount: 15,
          couponDesc: 'Get 30% discount',
          couponID: 'XMKG4G',
        },
      ],
      quantity: 1,
      sellPrice: 50,
    },
  ],
};

const _api_base_url = `${BASE_URL}/lmr/getCouponDetails`;
// const _api_base_url =
//   'https://run.mocky.io/v3/621c5948-2b36-4c36-94f6-6de9574269cc';

// const _api_base_url_couponpoints = `${BASE_URL}/lmr/get-points`;
const _api_base_url_couponpoints =
  'https://run.mocky.io/v3/0da827df-5de9-4c54-aa0a-92d523f70893';

const transaction_status_url =
  'http://localhost:3000/verify-payment/ORDERID_9914';

interface SearchItemRequest {
  payload: {
    storeID: string;
    orderID: string;
    itemID: string;
  };
  //   accessToken: string | null;
}

interface LineItems {
  item: string;
  itemIdentifier: string;
  quantity: number;
  unitPrice: number;
  discountedItem?: string;
}

interface PromoRequest {
  //   accessToken: string | null;
  payload: {
    storeID: string;
    orderID: string;
    lineItems: LineItems[];
  };
}

type PromoList = {
  discountAmount: number;
  promoDesc: string;
  promoID: string;
};

type ItemList = {
  itemIdentifier: string;
  discountAmount: number;
  extSellPrice: number;
  itemID: string;
  promoList: PromoList[] | [];
  quantity: number;
  sellPrice: number;
};

type ProductObj = {
  itemDesc: string;
  itemDept: string;
  itemBrand: string;
  itemColour: string;
  itemSize: string;
};

type PromoResponse = {
  storeID: string;
  orderID: string;
  itemList: ItemList[];
  productList: {[key: string]: ProductObj};
};

type PriceList = {
  sellPrice: number;
  discountAmount: number;
  extSellPrice: number;
  promoList: PromoList[];
};
type ItemDetail = {
  itemID: string;
  itemDesc: string;
  itemDept: string;
  itemBrand: string;
  itemColour: string;
  itemSize: string;
  mmrpFlag: string;
  priceList: PriceList[];
};
type SearchItemResponse = {
  statusCode: string;
  message: string;
  storeID: string;
  orderID: string;
  itemDetail: ItemDetail[];
};
type GiftCouponList = {
  discountAmount?: number;
  couponDesc?: string;
  couponID?: string;
};

type CouponItemList = {
  itemIdentifier: string;
  discountAmount: number;
  extSellPrice: number;
  itemID: string;
  giftCouponList: GiftCouponList[];
  quantity: number;
  sellPrice: number;
};

type ApplyCouponResponse = {
  statusCode: string;
  message: string;
  storeID: string;
  orderID: string;
  itemList: CouponItemList[];
};
interface ApplyCouponRequest {
  //   accessToken: string | null;
  payload: {
    storeID: string;
    orderID: string;
    couponID: string;
    lineItems: LineItems[];
  };
}

export const searchItem = async (
  parameters: SearchItemRequest,
): Promise<SearchItemResponse> => {
  try {
    //const req = JSON.stringify(parameters.payload);
    const response = await httpClient.post(
      `${_api_base_url_couponpoints}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          //   Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    //TODO: uncomment later
    //return response.data;
    //TODO: remove later
    return mockItemResponse;
  } catch (error) {
    throw new APIError(error);
  }
};
export const getPromoList = async (
  parameters: PromoRequest,
): Promise<PromoResponse> => {
  try {
    //const req = JSON.stringify(parameters.payload);
    const response = await httpClient.post(
      `${_api_base_url_couponpoints}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          //   Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    //TODO: uncomment later
    //return response.data;
    //TODO: remove later
    return mockResponse;
  } catch (error) {
    throw new APIError(error);
  }
};

export const applyCouponApi = async (
  parameters: ApplyCouponRequest,
): Promise<ApplyCouponResponse> => {
  try {
    //const req = JSON.stringify(parameters.payload);
    const response = await httpClient.post(
      `${_api_base_url_couponpoints}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          //   Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    //TODO: uncomment later
    //return response.data;
    //TODO: remove later
    return mockCouponResponse;
  } catch (error) {
    throw new APIError(error);
  }
};

// type PaymentRequest = {
//   payload: {
//     checksum: string;
//   };
//   // accessToken: string;
// };
